var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.name ==='login' || _vm.$route.name ==='reset')?_c('NoLayout',[_c('router-view')],1):_c('AppLayout',[_c('router-view')],1),_c('notifications',{attrs:{"position":"bottom left","classes":"notification-card"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }